import { nanoid } from 'nanoid';
import { SDK_VERSION } from '../version';
export class DataServiceApi {
    constructor(threads, dapps, dappNotificationTypes, dappNotificationSubscriptions, walletsV0, walletAddresses, walletDappAddresses, walletMessages, walletNotificationSubscriptions, pushNotificationSubscriptions, health) {
        this.threads = threads;
        this.dapps = dapps;
        this.dappNotificationTypes = dappNotificationTypes;
        this.dappNotificationSubscriptions = dappNotificationSubscriptions;
        this.walletsV0 = walletsV0;
        this.walletAddresses = walletAddresses;
        this.walletDappAddresses = walletDappAddresses;
        this.walletMessages = walletMessages;
        this.walletNotificationSubscriptions = walletNotificationSubscriptions;
        this.pushNotificationSubscriptions = pushNotificationSubscriptions;
        this.health = health;
    }
}
export class NetworkError {
}
export class DataServiceApiError {
    constructor(error, statusCode, message, requestId) {
        this.error = error;
        this.statusCode = statusCode;
        this.message = message;
        this.requestId = requestId;
    }
}
const XRequestIdHeader = 'x-request-id';
const XClientNameHeader = 'x-client-name';
const XClientVersionHeader = 'x-client-version';
export function createHeaders(token) {
    return {
        ...(token && {
            Authorization: `Bearer ${token.rawValue}`,
        }),
        [XRequestIdHeader]: nanoid(),
        [XClientNameHeader]: 'dialect-sdk',
        [XClientVersionHeader]: SDK_VERSION,
    };
}
export async function withReThrowingDataServiceError(fn) {
    var _a;
    try {
        return await fn;
    }
    catch (e) {
        console.error(e);
        const err = e;
        if (!err.response) {
            throw new NetworkError();
        }
        const data = err.response.data;
        const requestId = (_a = (err.config.headers &&
            err.config.headers[XRequestIdHeader])) !== null && _a !== void 0 ? _a : null;
        throw new DataServiceApiError(err.response.statusText, Number(err.response.status), data.message, requestId);
    }
}
//# sourceMappingURL=data-service-api.js.map